<template>
  <div>
    <!-- <div
      class="w-full flex justify-center h-12 bg-red-500 items-center text-white"
    >
      <p class="mr-2">
        Nově se nám uvolnil víkend od 25. 9. 2021 do 26. 9. 2021!
      </p>
      <a class="underline" href="/rezervace">Zarezervujte si pobyt</a>
    </div> -->
    <ProvozniradModal />
    <Navbar />
    <slot />
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";
import ProvozniradModal from "../components/ProvozniradModal.vue";

export default {
  components: {
    Navbar,
    Footer,
    ProvozniradModal,
  },
};
</script>
